import 'bootstrap/dist/css/bootstrap.css';
import "./src/styles/global.scss"